import preCheckService from './PreCheckService';

const RoomScanSelector = {
    previousStepsAreCompleted() {
        return preCheckService.readinessCheckCompleted()
            && preCheckService.audioVideoCheckCompleted()
            && preCheckService.idVerificationCompleted()
            && preCheckService.manualIdVerificationCompleted();
    },

    isCompleted(
        state,
        idverification,
        isPreviousStepsCompleted = this.previousStepsAreCompleted(state, idverification),
    ) {
        return (
            isPreviousStepsCompleted
            && (state.isRoomScanConfirmed || state.cachedIsRoomScanConfirmed)
        );
    },

    showOpenRoomScanButton(
        state,
        idverification,
        isPreviousStepsCompleted = this.previousStepsAreCompleted(state, idverification),
        isCompleted = this.isCompleted(state, idverification),
    ) {
        return (
            isPreviousStepsCompleted
            && !isCompleted
        );
    },
};

export default RoomScanSelector;
